@if (comments$ | async; as comments) {
  @if ((unresolvedCommentCount$ | async) === 0 && !showResolved) {
    @if ((resolvedCommentCount$ | async) === 0) {
      <!-- No comments at all -->
      <div class="no-comments">
        <app-svg src="/assets/icons/64/comments.svg" size="2"></app-svg>
        <p>Start the conversation by leaving the first comment below.</p>
      </div>
    } @else {
      <!-- All comments resolved -->
      <div class="no-comments">
        <app-svg src="/assets/icons/64/comments-resolved.svg" size="2"></app-svg>
        <p>Great job! All comments on this asset are resolved.</p>

        @if (resolvedCommentCount$ | async; as resolvedCommentCount) {
          <button
            appButton
            name="toggle-resolved"
            location="comments"
            color="simple"
            size="1"
            height="1"
            shape="round"
            [center]="true"
            (click)="toggleShowResolved.emit()"
          >
            Show Resolved ({{ resolvedCommentCount }})
          </button>
        }
      </div>
    }
  } @else {
    <div
      class="threads"
      appClickOutside
      (onClickOutside)="selectThread(undefined)"
      [exceptionElementNames]="['app-wysiwyg-toolbar', 'app-context-menu-global']"
      #threads
    >
      @for (thread of comments | resolvedComments: showResolved; track thread.id) {
        <app-comment-thread
          [id]="thread.id"
          [gallery]="gallery()"
          [asset]="asset"
          [thread]="thread"
          [replies]="thread.replies"
          [galleryPermissions]="galleryPermissions()"
          [enabledAndAllowedFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
          [isTeamMember]="isTeamMember"
          [me]="state.user || state.guest"
          [selected]="selectedThread()?.id === thread.id"
          [hover]="hoverThreadId === thread.id"
          [expandReplies]="selectedThread()?.id === thread.id"
          (resolveThread)="resolveThread(thread, $event)"
          (deleteComment)="deleteComment($event)"
          (toggleSelectedThread)="toggleSelectedThread(thread)"
          (selectThread)="selectThread(thread)"
          (threadHover)="threadHover.emit($event)"
          (unselect)="selectThread(undefined)"
          (replyFocusChanged)="replyFocusChanged($event)"
        ></app-comment-thread>
      }
    </div>

    @if (resolvedCommentCount$ | async; as resolvedCommentCount) {
      <button
        appButton
        name="toggle-resolved"
        location="comments"
        color="simple"
        size="1"
        height="1"
        shape="round"
        [center]="true"
        (click)="toggleShowResolved.emit()"
      >
        @if (showResolved) {
          Hide Resolved
        } @else {
          Show Resolved
        }
        ({{ resolvedCommentCount }})
      </button>
    }
  }
}
@if (
  !hideNewCommentThread && (!replyFocused() || isDesktop) && allowedAndEnabledFeedbackOptions().includes('comment')
) {
  <app-new-comment-thread
    [@newCommentThread]
    [me]="state.user || state.guest"
    [annotationMode]="annotationMode"
    [asset]="asset"
    [gallery]="gallery()"
    [commentMessage]="commentMessage"
    [commentPlacementMode]="commentPlacementMode"
    [enabledAndAllowedFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
    [galleryPermissions]="galleryPermissions()"
    [isTeamMember]="isTeamMember"
    (thread)="postNewThread($event.text, $event.addVideoFramePosition)"
    (toggleAnnotationMode)="toggleAnnotationMode.emit()"
    (placeComment)="placeComment.emit($event)"
  ></app-new-comment-thread>
}
